<template>
  <div class="app-orders">
    <v-header v-bind:user="user"></v-header>
    <div class="orders-table">
      <orders-list :user="user" :selectable="true" :mainPage="true"></orders-list>
    </div>
  </div>
</template>

<script>
import VHeader from "../components/header";
import OrdersList from "../components/user/orders/OrdersTable.vue";
import User from "@/models/User.js";

// @ is an alias to /src
export default {
  name: "app-orders",
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    OrdersList,
    VHeader,
  },
};
</script>

<style scoped>
.orders-table {
  width: 100%;
}
</style>